import { render, staticRenderFns } from "./ProductcenterSiLView.vue?vue&type=template&id=04321352&scoped=true"
import script from "./ProductcenterSiLView.vue?vue&type=script&lang=js"
export * from "./ProductcenterSiLView.vue?vue&type=script&lang=js"
import style0 from "./ProductcenterSiLView.vue?vue&type=style&index=0&id=04321352&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04321352",
  null
  
)

export default component.exports